import Vue from 'vue'
import updateAbility from '../config/updateAbility'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Dashboard from '../views/Dashboard/Dashboard.vue'
import Customers from '../views/Customers/Customers.vue'
import CreateupdateCustomer from '../views/Customers/CreateupdateCustomer.vue'
import CustomerHistory from '../views/Customers/CustomerHistory.vue'
import ImportCustomers from '../views/Customers/ImportCustomers.vue'
import CustomersConfiguration from '../views/Customers/CustomersConfiguration.vue'

import SalesNoteCreateUpdate from '../views/Sales/SalesNoteCreateUpdate.vue'
import SalesNotes from '../views/Sales/SalesNotes.vue'
import SalesNoteDetail from '../views/Sales/SalesNoteDetail.vue'
import SalesNoteConfiguration from '../views/Sales/SalesNoteConfiguration.vue'
import Activities from '../views/Sales/Activities.vue'

import Products from '../views/Products/Products.vue'
import InvoicingDashboard from '../views/Sales/InvoicingDashboard.vue'
import ImportProducts from '../views/Products/ImportProducts.vue'

import FamilyLine from '../views/Products/FamilyLine.vue'
import ProductCreateUpdate from '../views/Products/ProductCreateUpdate.vue'
import Costs from '../views/Products/Costs.vue'
import Processes from '../views/Products/Processes.vue'
import ImportProcesses from '../views/Products/ImportProcesses.vue'
import ImportSupplies from '../views/Products/ImportSupplies.vue'
import BatchUpdate from '../views/Products/BatchUpdate.vue'
import Supplies from '../views/Products/Supplies.vue'
import CostsGroupUnit from '../views/Products/CostsGroupUnit.vue'
import Login from '../views/Auth/Login.vue'
import Users from '../views/Users/Users.vue'
import CreateupdateUser from '../views/Users/CreateupdateUser.vue'
import PasswordResetEmail from '../views/Auth/PasswordResetEmail.vue'
import PasswordResetRequest from '../views/Auth/PasswordResetRequest.vue'
import ParametersManager from '../views/Parameters/ParametersManager.vue'
import RoleCreateUpdate from '../views/Users/RoleCreateUpdate.vue'
import machines from '../views/production/machines.vue'
import WorkOrders from '../views/production/WorkOrders.vue'
import ProductsInPrestage from '../views/production/ProductsInPrestage.vue'

import MainPlanner2 from '../views/production/MainPlanner2.vue'
import CompletedProcess from '../views/production/CompletedProcess.vue'
import WorkOrderUpdate from '../views/production/WorkOrderUpdate.vue'
import FloorControl from '../views/production/FloorControl.vue'
import CompromiseCalendar2 from '../views/production/CompromiseCalendar2.vue'
import DeliveryCommitmentsDashboard from '../views/Reports/DeliveryCommitmentsDashboard.vue'
import InventoryDashboard from '../views/Reports/InventoryDashboard.vue'
import ProductionDashboard from '../views/Reports/ProductionDashboard.vue'
import CommercialDashboard from '../views/Reports/CommercialDashboard.vue'
import Stages from '../views/production/Stages.vue'
import PostCostWorkOrders from '../views/Reports/PostCostWorkOrders.vue'
import DetailedPostCost from '../views/Reports/DetailedPostCost.vue'
import ProductInvoiceReport from '../views/Reports/ProductInvoiceReport.vue'
import InvoicedWorkOrders from '../views/Reports/InvoicedWorkOrders.vue'
import RelbaseSyncReport from '../views/Reports/RelbaseSyncReport.vue'
import RelbaseProductBillingReport from '../views/Reports/RelbaseProductBillingReport.vue'
import ProductSalesReport from '../views/Reports/ProductSalesReport.vue'
import FamilySalesReport from '../views/Reports/FamilySalesReport.vue'
import ProductionBitacora from '../views/Reports/ProductionBitacora.vue'
import ConsumeBitacora from '../views/Reports/ConsumeBitacora.vue'
import ConsumeOTBitacora from '../views/Reports/ConsumeOTBitacora.vue'
import WorkOrdersMoney from '../views/Reports/WorkOrdersMoney.vue'

import SupplyOrdersPendingReport from '../views/Reports/SupplyOrdersPendingReport.vue'
import NotificationLog from '../views/Notifications/NotificationLog.vue'
import StocksConfiguration from '../views/Stocks/StocksConfiguration'
import CreateTransaction from '../views/Stocks/CreateTransaction'
import SuccessTransaction from '../views/Stocks/SuccessTransaction'
import StoreTransfers from '../views/Stocks/StoreTransfers'
import CreateStoreTransfer from '../views/Stocks/CreateStoreTransfer'
import Articles from '../views/Stocks/Articles'
import Stock from '../views/Stocks/Stock'
import Transactions from '../views/Stocks/Transactions'
import ImportStock from '../views/Stocks/ImportStock'
import ImportProviders from '../views/Stocks/ImportProviders'
import DetailedArticle from '../views/Stocks/DetailedArticle.vue'
import PurchaseOrders from '../views/Stocks/PurchaseOrders.vue'
import CreatePurchaseOrder from '../views/Stocks/CreatePurchaseOrder.vue'
import PurchaseInvoices from '../views/purchases/PurchaseInvoices.vue'
import CreatePurchaseInvoice from '../views/purchases/CreatePurchaseInvoice.vue'
import AccountsReceivable from '../views/finance/AccountsReceivable.vue'
import AccountsPayable from '../views/finance/AccountsPayable.vue'
import FinanceCollections from '../views/finance/Collections.vue'
import FinanceTreasury from '../views/finance/Treasury.vue'
import FinanceReconciliation from '../views/finance/Reconciliation.vue'
import FinanceCashflow from '../views/finance/Cashflow.vue'
import FinanceDashboard from '../views/finance/Dashboard.vue'
import FinanceCostCenters from '../views/finance/CostCenters.vue'
import FinanceBudgets from '../views/finance/Budgets.vue'
import FinanceOtProfitability from '../views/finance/OtProfitability.vue'
import CrmPipeline from '../views/crm/Pipeline.vue'
import CrmOpportunity from '../views/crm/OpportunityDetail.vue'
import Invoices from '../views/Sales/Invoices.vue'
import CreateDTE from '../views/Sales/CreateDTE.vue'
import BulkDispatch from '../views/Sales/BulkDispatch.vue'
import BulkDispatchBatch from '../views/Sales/BulkDispatchBatch.vue'
import PackingSlips from '../views/Sales/PackingSlips.vue'
import CreatePackingSlip from '../views/Sales/CreatePackingSlip.vue'
import Documents from '../views/Softnet/Documents.vue'
import KameDocuments from '../views/Kame/KameDocuments.vue'
import Congratulations from '../views/Alertas/Congratulations.vue'
import SellerMapping from '../views/relbase/SellerMapping.vue'
import FamilyMapping from '../views/relbase/FamilyMapping.vue'
import RelbaseSettings from '../views/relbase/RelbaseSettings.vue'
import RelbaseDocumentsList from '../views/relbase/RelbaseDocumentsList.vue'

import store from '../store'

import notifications from '../utils/notifications'
import ability from '../config/ability'
import { financeModuleKeyFromPath, isFinanceModuleEnabled } from '@/utils/financeModules'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
},
{
    path: '/felicitaciones',
    name: 'Congratulations',
    component: Congratulations,
    meta: { requiresAuth: true }
},
{
    path: '/notifications/log',
    name: 'NotificationLog',
    component: NotificationLog,
    meta: { requiresAuth: true }
},
{
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
},
{
    path: '/customers',
    name: 'Customers',
    component: Customers,
    meta: { requiresAuth: true }
},
{
    path: '/customers/create-update/:customerId?',
    name: 'CustomersCreateUpdate',
    component: CreateupdateCustomer,
    meta: { requiresAuth: true }
},
{
    path: '/customers/:customerId/history',
    name: 'CustomerHistory',
    component: CustomerHistory,
    meta: { requiresAuth: true }
},
{
    path: '/customers/import',
    name: 'ImportCustomers',
    component: ImportCustomers,
    meta: { requiresAuth: true }
},
{
    path: '/customers/configuration',
    name: 'CustomersConfiguration',
    component: CustomersConfiguration,
    meta: { requiresAuth: true }
},
{
    path: '/products/costs',
    name: 'Costs',
    component: Costs,
    meta: { requiresAuth: true }
},
{
    path: '/products/processes',
    name: 'Processes',
    component: Processes,
    meta: { requiresAuth: true }
},
{
    path: '/products/processes/import/:data?',
    name: 'ImportProcesses',
    component: ImportProcesses,
    meta: { requiresAuth: true }
},
{
    path: '/products/supplies/import/:data?',
    name: 'ImportSupplies',
    component: ImportSupplies,
    meta: { requiresAuth: true }
},
{
    path: '/products/supplies',
    name: 'Supplies',
    component: Supplies,
    meta: { requiresAuth: true }
},
{
    path: '/products/costs/groups-units',
    name: 'CostsGroupUnit',
    component: CostsGroupUnit,
    meta: { requiresAuth: true }
},
{
    path: '/products/create-update/:product?',
    name: 'ProductCreateUpdate',
    component: ProductCreateUpdate,
    meta: { requiresAuth: true }
},
{
    path: '/products',
    name: 'Products',
    component: Products,
    meta: { requiresAuth: true }
},
{
    path: '/products/import',
    name: 'ImportProducts',
    component: ImportProducts,
    meta: { requiresAuth: true }
},
{
    path: '/products/batch-update',
    name: 'BatchUpdate',
    component: BatchUpdate,
    meta: { requiresAuth: true }
},
{
    path: '/products/family-line',
    name: 'FamilyLine',
    component: FamilyLine,
    meta: { requiresAuth: true }
},
{
    path: '/sales',
    name: 'SaleNotes',
    component: SalesNotes,
    meta: { requiresAuth: true }
},
{
    path: '/finanzas/dashboard-facturacion',
    name: 'InvoicingDashboard',
    component: InvoicingDashboard,
    meta: { requiresAuth: true, dashboardPermission: 'DashboardRetainedCapital' }
},
{
    path: '/sales/invoices',
    name: 'Invoices',
    component: Invoices,
    meta: { requiresAuth: true }
},

{
    path: '/sales/create-dte/:id?/:tipo?',
    name: 'CreateDTE',
    component: CreateDTE,
    meta: { requiresAuth: true }
},
{
    path: '/sales/bulk-dispatch',
    name: 'BulkDispatch',
    component: BulkDispatch,
    meta: { requiresAuth: true }
},
{
    path: '/sales/bulk-dispatch/:batchId',
    name: 'BulkDispatchBatch',
    component: BulkDispatchBatch,
    meta: { requiresAuth: true }
},
{
    path: '/sales/packing-slips',
    name: 'PackingSlips',
    component: PackingSlips,
    meta: { requiresAuth: true }
},
{
    path: '/sales/create-packing-slip/:id?',
    name: 'CreatePackingSlip',
    component: CreatePackingSlip,
    meta: { requiresAuth: true }
},
{
    path: '/sales/sales-note-detail/:sales_note',
    name: 'SalesNoteDetail',
    component: SalesNoteDetail,
    meta: { requiresAuth: true }
},
{
    path: '/sales/sale-note/:id?/:duplicate?',
    name: 'SalesNoteCreateUpdate',
    component: SalesNoteCreateUpdate,
    meta: { requiresAuth: true }
},
{
    path: '/sales/softnet-documents',
    name: 'Documents',
    component: Documents,
    meta: { requiresAuth: true }
},
{
    path: '/sales/kame-documents',
    name: 'KameDocuments',
    component: KameDocuments,
    meta: { requiresAuth: true }
},
{
    path: '/sales/simplefactura-documents',
    redirect: '/sales/invoices',
},
{
    path: '/sales/facturacioncl-documents',
    redirect: '/sales/invoices',
},
{
    path: '/sales/emitir-boleta',
    redirect: '/sales/create-dte/-1/39',
},
{
    path: '/sales/configuration',
    name: 'SalesNoteConfiguration',
    component: SalesNoteConfiguration,
    meta: { requiresAuth: true }
},
{
    path: '/sales/activities',
    name: 'Activities',
    component: Activities,
    meta: { requiresAuth: true }
},
{
    path: '/production/machines',
    name: 'machines',
    component: machines,
    meta: { requiresAuth: true }
},
{
    path: '/production/work-orders',
    name: 'WorkOrders',
    component: WorkOrders,
    meta: { requiresAuth: true }
},
{
    path: '/production/products-in-prestage',
    name: 'ProductsInPrestage',
    component: ProductsInPrestage,
    meta: { requiresAuth: true }
},
{
    path: '/production/main-planner2',
    name: 'MainPlanner',
    component: MainPlanner2,
    meta: { requiresAuth: true }
},
{
    path: '/production/completed-process',
    name: 'CompletedProcess',
    component: CompletedProcess,
    meta: { requiresAuth: true }
},
{
    path: '/production/work-order-update/:workOrder',
    name: 'WorkOrderUpdate',
    component: WorkOrderUpdate,
    meta: { requiresAuth: true }
},
{
    path: '/production/floor-control',
    name: 'FloorControl',
    component: FloorControl,
    meta: { requiresAuth: true }
},
{
    path: '/production/compromise-calendar',
    name: 'CompromiseCalendar2',
    component: CompromiseCalendar2,
    meta: { requiresAuth: true }
},
{
    path: '/production/stages',
    name: 'Stages',
    component: Stages,
    meta: { requiresAuth: true }
},
{
    path: '/reports/post-cost',
    name: 'PostCostWorkOrders',
    component: PostCostWorkOrders,
    meta: { requiresAuth: true }
},
{
    path: '/reports/post-cost/:id',
    name: 'DetailedPostCost',
    component: DetailedPostCost,
    meta: { requiresAuth: true }
},
{
    path: '/reports/product-sales',
    name: 'ProductSalesReport',
    component: ProductSalesReport,
    meta: { requiresAuth: true }
},
{
    path: '/reports/product-invoice',
    name: 'ProductInvoiceReport',
    component: ProductInvoiceReport,
    meta: { requiresAuth: true }
},
{
    path: '/reports/work-order-invoice',
    name: 'InvoicedWorkOrders',
    component: InvoicedWorkOrders,
    meta: { requiresAuth: true }
},
{
    path: '/reports/family-sales',
    name: 'FamilySalesReport',
    component: FamilySalesReport,
    meta: { requiresAuth: true }
},
{
    path: '/reports/supply-orders',
    name: 'SupplyOrdersPendingReport',
    component: SupplyOrdersPendingReport,
    meta: { requiresAuth: true }
},
{
    path: '/reports/production-bitacora',
    name: 'ProductionBitacora',
    component: ProductionBitacora,
    meta: { requiresAuth: true }
},
{
    path: '/reports/consume-bitacora',
    name: 'ConsumeBitacora',
    component: ConsumeBitacora,
    meta: { requiresAuth: true }
},
{
    path: '/reports/relbase-sync',
    name: 'RelbaseSyncReport',
    component: RelbaseSyncReport,
    meta: { requiresAuth: true }
},
{
    path: '/reports/relbase-product-billing',
    name: 'RelbaseProductBillingReport',
    component: RelbaseProductBillingReport,
    meta: { requiresAuth: true }
},
{
    path: '/reports/work-order-money',
    name: 'WorkOrdersMoney',
    component: WorkOrdersMoney,
    meta: { requiresAuth: true }
},
{
    path: '/reports/consume-ot-bitacora',
    name: 'ConsumeOTBitacora',
    component: ConsumeOTBitacora,
    meta: { requiresAuth: true }
},
{
    path: '/reports/delivery-commitments',
    name: 'DeliveryCommitmentsDashboard',
    component: DeliveryCommitmentsDashboard,
    meta: { requiresAuth: true, dashboardPermission: 'DashboardDeliveries' }
},
{
    path: '/reports/inventory',
    name: 'InventoryDashboard',
    component: InventoryDashboard,
    meta: { requiresAuth: true, dashboardPermission: 'DashboardInventory' }
},
{
    path: '/reports/production',
    name: 'ProductionDashboard',
    component: ProductionDashboard,
    meta: { requiresAuth: true, dashboardPermission: 'DashboardProduction' }
},
{
    path: '/reports/commercial',
    name: 'CommercialDashboard',
    component: CommercialDashboard,
    meta: { requiresAuth: true, dashboardPermission: 'DashboardSales' }
},
{
    path: '/stocks/articles',
    name: 'Articles',
    component: Articles,
    meta: { requiresAuth: true }
},
{
    path: '/stocks/configuration',
    name: 'StocksConfiguration',
    component: StocksConfiguration,
    meta: { requiresAuth: true }
},
{
    path: '/stocks/create-transaction',
    name: 'CreateTransaction',
    component: CreateTransaction,
    meta: { requiresAuth: true }
},
{
    path: '/stocks/store-transfers',
    name: 'StoreTransfers',
    component: StoreTransfers,
    meta: { requiresAuth: true }
},
{
    path: '/stocks/store-transfers/create',
    name: 'CreateStoreTransfer',
    component: CreateStoreTransfer,
    meta: { requiresAuth: true }
},
{
    path: '/stocks/success-transaction',
    name: 'SuccessTransaction',
    component: SuccessTransaction,
    meta: { requiresAuth: true }
},
{
    path: '/stocks/stock',
    name: 'Stock',
    component: Stock,
    meta: { requiresAuth: true }
},
{
    path: '/stocks/transactions',
    name: 'Transactions',
    component: Transactions,
    meta: { requiresAuth: true }
},
{
    path: '/stocks/import-stock',
    name: 'ImportStock',
    component: ImportStock,
    meta: { requiresAuth: true }
},
{
    path: '/stocks/import-providers',
    name: 'ImportProviders',
    component: ImportProviders,
    meta: { requiresAuth: true }
},
{
    path: '/stocks/detailed-article/:id',
    name: 'DetailedArticle',
    component: DetailedArticle,
    meta: { requiresAuth: true }
},
{
    path: '/stocks/purchase-orders',
    name: 'PurchaseOrders',
    component: PurchaseOrders,
    meta: { requiresAuth: true }
},
{
    path: '/stocks/purchase-orders-create/:id?/:duplicate?',
    name: 'CreatePurchaseOrder',
    component: CreatePurchaseOrder,
    meta: { requiresAuth: true }
},
{
    path: '/purchases/invoices',
    name: 'PurchaseInvoices',
    component: PurchaseInvoices,
    meta: { requiresAuth: true }
},
{
    path: '/purchases/invoices-create/:id',
    name: 'CreatePurchaseInvoice',
    component: CreatePurchaseInvoice,
    meta: { requiresAuth: true }
},
{
    path: '/finance/dashboard',
    name: 'FinanceDashboard',
    component: FinanceDashboard,
    meta: { requiresAuth: true }
},
{
    path: '/finance/cost-centers',
    name: 'FinanceCostCenters',
    component: FinanceCostCenters,
    meta: { requiresAuth: true }
},
{
    path: '/finance/budgets',
    name: 'FinanceBudgets',
    component: FinanceBudgets,
    meta: { requiresAuth: true }
},
{
    path: '/finance/ot-profitability',
    name: 'FinanceOtProfitability',
    component: FinanceOtProfitability,
    meta: { requiresAuth: true }
},
{
    path: '/crm/pipeline',
    name: 'CrmPipeline',
    component: CrmPipeline,
    meta: { requiresAuth: true }
},
{
    path: '/crm/opportunities/:id',
    name: 'CrmOpportunity',
    component: CrmOpportunity,
    meta: { requiresAuth: true }
},
{
    path: '/finance/ar',
    name: 'AccountsReceivable',
    component: AccountsReceivable,
    meta: { requiresAuth: true }
},
{
    path: '/finance/ap',
    name: 'AccountsPayable',
    component: AccountsPayable,
    meta: { requiresAuth: true }
},
{
    path: '/finance/collections',
    name: 'FinanceCollections',
    component: FinanceCollections,
    meta: { requiresAuth: true }
},
{
    path: '/finance/treasury',
    name: 'FinanceTreasury',
    component: FinanceTreasury,
    meta: { requiresAuth: true }
},
{
    path: '/finance/reconciliation',
    name: 'FinanceReconciliation',
    component: FinanceReconciliation,
    meta: { requiresAuth: true }
},
{
    path: '/finance/cashflow',
    name: 'FinanceCashflow',
    component: FinanceCashflow,
    meta: { requiresAuth: true }
},
{
    path: '/parameters',
    name: 'ParametersManager',
    component: ParametersManager,
    meta: { requiresAuth: true }
},

{
    path: '/auth/login',
    name: 'Login',
    component: Login,

},
{
    path: '/auth/password-reset/email',
    name: 'PasswordResetEmail',
    component: PasswordResetEmail,

},
{
    path: '/auth/password-reset/:token',
    name: 'PasswordResetRequest',
    component: PasswordResetRequest,

},
{
    path: '/users',
    name: 'Users',
    component: Users,
    meta: { requiresAuth: true }
},
{
    path: '/users/create-update/:id',
    name: 'UsersCreateUpdate',
    component: CreateupdateUser,
    meta: { requiresAuth: true }
},
{
    path: '/users/role-create-update/:id',
    name: 'RoleCreateUpdate',
    component: RoleCreateUpdate
},
{
    path: '/relbase/seller-mapping',
    name: 'SellerMapping',
    component: SellerMapping,
    meta: { requiresAuth: true }
},
{
    path: '/relbase/family-mapping',
    name: 'FamilyMapping',
    component: FamilyMapping,
    meta: { requiresAuth: true }
},
{
    path: '/relbase/settings',
    name: 'RelbaseSettings',
    component: RelbaseSettings,
    meta: { requiresAuth: true }
},
{
    path: '/ventas/relbase-documents',
    name: 'RelbaseDocumentsList',
    component: RelbaseDocumentsList,
    meta: { requiresAuth: true }
},
{
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
        import( /* webpackChunkName: "about" */ '../views/About.vue')
}
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

//Solución para resguardar las rutas

router.beforeEach(async (to, from, next) => {
    const token = localStorage.getItem('access_token')
    var user = store.getters.getUser
    if (to.matched.some(record => record.meta.requiresAuth)) {
        //Condición de prueba para evitar la tomada de datos al principio
        //Se probará con el docker
        if (to.matched.some(record => record.name == 'Home') && !user) {
            next('/auth/login')
            return 0
        }
        if (!user) {
            await store.dispatch('getMe')
                .then(() => {
                    user = store.getters.getUser
                    updateAbility(user)
                })
                .catch(() => next('/auth/login'))
        }
        if (!token | !user) {
            next('/auth/login')
        } else {
            const company = store.getters.getCompany || {}
            if (to.path.startsWith('/finance/')) {
                if (!company.finance_enabled) {
                    notifications.showError('RUNFLOW Finance no está activo para esta empresa.')
                    next('/')
                    return
                }
                const moduleKey = financeModuleKeyFromPath(to.path)
                if (moduleKey && !isFinanceModuleEnabled(company, moduleKey)) {
                    notifications.showError('Este módulo de Finance no está habilitado.')
                    next('/')
                    return
                }
            }
            const dashboardPermission = to.meta && to.meta.dashboardPermission
            if (dashboardPermission && !ability.can('read', dashboardPermission)) {
                notifications.showError('No tiene permisos para ver este dashboard.')
                next('/')
                return
            }
            if (store.getters.getPaymentRequest == 1) {
                notifications.showError('Su servicio presenta un problema de pago, por favor comuníquese con el administrador para evitar la suspención de su cuenta.')
                setTimeout(() => {
                    next()
                }, 5000);
            }
            else next()
        }
    } else next();
});

export default router